<div class="list-item">
  <div class="label">{{ label }}</div>
  <div class="text-value" *ngIf="!!url; else pill">
    <a class="text-link" [routerLink]="url">{{ text }}</a>
  </div>
</div>

<ng-template #pill>
  <div *ngIf="statusPills?.length; else profileBadge" class="d-flex gap-2 flex-wrap justify-content-end">
    <app-status-pill *ngFor="let pill of statusPills; trackBy: trackByPillName" [statusPill]="pill" />
  </div>
</ng-template>
<ng-template #profileBadge>
  <app-user-profile-badge
    *ngIf="profileBadgeConfiguration || initials; else simpleString"
    [profileBadgeConfiguration]="profileBadgeConfiguration"
    [initials]="initials" />
</ng-template>
<ng-template #simpleString
  ><div class="text-value">{{ text }}</div></ng-template
>
